import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogSampleType } from "../models/CatalogSampleType";

type Props = {
  setSampleType: (sample_type: CatalogSampleType) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewSampleType: () => void;
};
export const useSampleTypesOptionsFunctions = ({
  setSampleType,
  setShowModal,
  handleNewSampleType,
}: Props) => {
  const getMenuOptions = (data: CatalogSampleType) => {
    let options: MenuOptionType[] = [
      {
        name: "New Sample Type",
        key: "new_sample_type",
        onClick: () => {
          handleNewSampleType();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Sample Type",
          key: "edit_sample_type",
          onClick: () => {
            setSampleType(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
